import RemoteImage from '@/components/Image/RemoteImage/RemoteImage';
import type {ImageModel} from '@/types/content';

type Props = {
    className?: string;
    imageMedia?: ImageModel[];
    pictureClassName?: string;
    imgClassName?: string;
};

const AemImage = ({className, imageMedia, pictureClassName, imgClassName}: Props) => {
    return (
        <div className={className}>
            <RemoteImage imageMedia={imageMedia} className={pictureClassName} imgClassName={imgClassName} />
        </div>
    );
};

export default AemImage;
